/**
 * MELP Mail Color Palette
 * Based on Google Material Design
 * Primary: #1a73e8 (Google Blue)
 */

export const colors = {
  primary: {
    main: '#1a73e8',
    light: '#4285f4',
    lighter: '#8ab4f8',
    lightest: '#c6dafc',
    dark: '#1557b0',
    darker: '#0d47a1',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#5f6368',
    light: '#80868b',
    dark: '#3c4043',
    contrastText: '#ffffff',
  },
  success: {
    main: '#34a853',
    light: '#81c995',
    dark: '#0d652d',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#fbbc04',
    light: '#fdd663',
    dark: '#f9ab00',
    contrastText: '#202124',
  },
  error: {
    main: '#ea4335',
    light: '#f28b82',
    dark: '#c5221f',
    contrastText: '#ffffff',
  },
  info: {
    main: '#1a73e8',
    light: '#8ab4f8',
    dark: '#1557b0',
    contrastText: '#ffffff',
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff',
    subtle: '#f8f9fa',
    hover: '#f1f3f4',
  },
  text: {
    primary: '#202124',
    secondary: '#5f6368',
    disabled: '#9aa0a6',
    hint: '#80868b',
  },
  divider: '#dadce0',
  grey: {
    50: '#f8f9fa',
    100: '#f1f3f4',
    200: '#e8eaed',
    300: '#dadce0',
    400: '#bdc1c6',
    500: '#9aa0a6',
    600: '#80868b',
    700: '#5f6368',
    800: '#3c4043',
    900: '#202124',
  },
};

export type Colors = typeof colors;

export const darkColors: Colors = {
  primary: {
    main: '#1a73e8',
    light: '#4285f4',
    lighter: '#8ab4f8',
    lightest: '#c6dafc',
    dark: '#1557b0',
    darker: '#0d47a1',
    contrastText: '#0b111a',
  },
  secondary: {
    main: '#9aa0a6',
    light: '#c1c7d0',
    dark: '#80868b',
    contrastText: '#0b111a',
  },
  success: {
    main: '#81c995',
    light: '#b4e1c5',
    dark: '#4b9b6a',
    contrastText: '#0b111a',
  },
  warning: {
    main: '#f6c344',
    light: '#f9d67a',
    dark: '#c49000',
    contrastText: '#0b111a',
  },
  error: {
    main: '#f28b82',
    light: '#f9b2ad',
    dark: '#c85b53',
    contrastText: '#0b111a',
  },
  info: {
    main: '#8ab4f8',
    light: '#aecbfa',
    dark: '#5f8de5',
    contrastText: '#0b111a',
  },
  background: {
    default: '#0f1116',
    paper: '#161b22',
    subtle: '#1b2433',
    hover: '#1f2a3a',
  },
  text: {
    primary: '#e8eaed',
    secondary: '#c5c8d3',
    disabled: '#8f96a3',
    hint: '#9fa6b2',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  grey: {
    50: '#1c2433',
    100: '#222c3d',
    200: '#2a3547',
    300: '#333f52',
    400: '#3d4a5e',
    500: '#48566b',
    600: '#5b6b82',
    700: '#7688a3',
    800: '#9badc5',
    900: '#c6d4e5',
  },
};
